module.exports = __webpack_public_path__ + "assets-cabinet/img/eye-ico.78c8e5f8.svg";